var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { Resizable } from "react-resizable";
export const ResizableTitle = (props) => {
    const { onResizeCallback, onResizeStop, width } = props, restProps = __rest(props, ["onResizeCallback", "onResizeStop", "width"]);
    const resizing = useRef(false);
    if (typeof onResizeCallback !== "function") {
        return _jsx("th", Object.assign({}, restProps));
    }
    return (_jsx(Resizable, { width: width, height: 0, handle: _jsx("span", { className: "react-resizable-handle", onClick: (e) => {
                e.stopPropagation();
            }, onMouseDown: (e) => e.stopPropagation() }), onResize: onResizeCallback, onResizeStart: () => {
            resizing.current = true;
        }, onResizeStop: () => {
            setTimeout(() => {
                resizing.current = false;
            }, 150);
            onResizeStop();
        }, draggableOpts: { enableUserSelectHack: false }, children: _jsx("th", Object.assign({}, restProps, { onClick: (e) => {
                if (resizing.current) {
                    e.preventDefault();
                }
                else if (typeof restProps.onClick === "function") {
                    restProps.onClick(e);
                }
            } })) }));
};
